import { createContext, useContext, useState, ReactNode } from "react";
import { FlatVsaaTag } from "../models/VsaaTag";
import { Dispatch } from "react";

interface SelectedTagContextType {
  selectedTag: FlatVsaaTag | undefined;
  setSelectedTag: Dispatch<React.SetStateAction<FlatVsaaTag | undefined>>;
}

const SelectedTagContext = createContext<SelectedTagContextType | undefined>(
  undefined
);

export const SelectedTagProvider = ({ children }: { children: ReactNode }) => {
  const [selectedTag, setSelectedTag] = useState<FlatVsaaTag | undefined>(
    undefined
  );

  return (
    <SelectedTagContext.Provider value={{ selectedTag, setSelectedTag }}>
      {children}
    </SelectedTagContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useSelectedTag = () => {
  const context = useContext(SelectedTagContext);
  return context;
};
